import { Injectable } from '@angular/core';
import {Category, CategoryList} from './category';
import {BaseService} from '../base/base.service';
import {CategorySerializer} from 'src/app/categories/category.serializer';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CategoryService extends BaseService<Category, CategoryList> {

  constructor(http: HttpClient) {
    super(http);
    this.endpoint = 'categories' ;
    this.serializer = new CategorySerializer();
  }
}
